/**
 * 行按钮（记录操作栏、卡片列表、时间轴）对生效页面按钮配置的命中。
 * 标识与配置扫描一致：value，没有则 key，再没有则 id。同一标识共用一条。
 * 未命中不改名称、不隐藏、不禁用。
 */

export function rowButtonFieldKey(btn: any): string {
  const raw = btn?.value ?? btn?.key ?? btn?.id;
  if (raw == null || raw === '') {
    return '';
  }
  return String(raw);
}

export function findRowButtonPageConfig(configs: any, btn: any) {
  const fieldKey = rowButtonFieldKey(btn);
  if (!fieldKey || !Array.isArray(configs)) {
    return null;
  }
  const matched = configs.filter((item) => item && String(item.fieldKey ?? '') === fieldKey);
  if (matched.length === 0) {
    return null;
  }
  return matched.find((item) => item.newFieldName === btn?.label) || matched[0];
}

/** 命中且 isDisplay 为 false 时不出现。未命中或其它值保持原显隐。 */
export function isRowButtonHiddenByPageConfig(configs: any, btn: any): boolean {
  const config = findRowButtonPageConfig(configs, btn);
  if (!config) {
    return false;
  }
  return config.isDisplay === false;
}

/** 命中且 isDisabled 为 true 时不可点。未命中不额外禁用。 */
export function isRowButtonDisabledByPageConfig(configs: any, btn: any): boolean {
  const config = findRowButtonPageConfig(configs, btn);
  if (!config) {
    return false;
  }
  return config.isDisabled === true;
}

/** 命中且新名称与当前文案不同时返回新名称，否则空串，调用方回退原名称。 */
export function rowButtonPageConfigLabel(configs: any, btn: any): string {
  const config = findRowButtonPageConfig(configs, btn);
  if (!config || !config.newFieldName) {
    return '';
  }
  return config.newFieldName === btn?.label ? '' : config.newFieldName;
}
